import { Box } from "@mui/material";
import { Layout } from "framework-react-core";
import LoadingScreen from "./views/Loading/LoadingScreen";

export function RootFallback() {
  return (
    <Layout title="Rules Engine" menuOptions={[{ label: "Home", path: "/" }]}>
      <Box>
        <LoadingScreen />
      </Box>
    </Layout>
  );
}

export default RootFallback;
